<template>
  <div class="logo">
    <img :src="imagePath" />
  </div>
</template>
<script>
export default {
  props: ["imagePath"]
};
</script>
<style lang="scss" scoped>
@import "../../../../scss/global.scss";

.logo {
  padding: 0.5rem;
  margin: 0;
  font-size: 0;
  img {
    width: 6rem;
  }
}

@media (min-width: $min-width-extended) {
  .logo {
    img {
      width: 10rem;
    }
  }
}
</style>
